/** Single place that reads `import.meta.env`. Everything else imports `envConfig`. */
export const envConfig = {
  /**
   * Relative by default so the Vite dev proxy (and any reverse proxy in production) handles routing.
   *
   * `||`, not `??`, on purpose. The Dockerfile declares `ARG VITE_API_BASE_URL` and then
   * `ENV VITE_API_BASE_URL=$VITE_API_BASE_URL`, so a build that passes no `--build-arg` bakes in the empty
   * string rather than leaving the variable undefined. `??` treats `''` as a real value, which resolved the
   * API base to the origin root and sent every call to `/auth/login` instead of `/api/auth/login` — a 405
   * from the static file handler. Falling back on any falsy value keeps the default intact either way.
   */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
} as const;

/** `OpenAPILink` builds requests with `new URL(...)`, which needs an absolute base. */
export const resolveApiBaseUrl = (): string => new URL(envConfig.apiBaseUrl, window.location.origin).toString();
